import gql from 'graphql-tag'
import client from '@stores/apollo'
import { EmployeeFragment } from '@api/fragments'
import { IEmployee } from '@api'

export default function fetchExemptFromCheckin(): Promise<IEmployee[]> {
  return client.gql.query({ query: exemptEmployeesQuery }).then(
    ({
      data: {
        viewer: {
          company: {
            employees: { edges },
          },
        },
      },
    }: {
      data: {
        viewer: {
          company: {
            employees: {
              edges: { node: IEmployee }[]
            }
          }
        }
      }
    }) => {
      return edges.map((e) => e.node)
    }
  )
}

export const exemptEmployeesQuery = gql`
  query exemptEmployees {
    viewer {
      company {
        employees(ValueFilter: EXEMPTED, sortBy: name) {
          edges {
            node {
              ...EmployeeFragment
            }
          }
        }
      }
    }
  }
  ${EmployeeFragment}
`
